import type { SxProps, Theme } from '@mui/material'
import { baseSkeletonStyles } from '../utils/skeleton'

export const styles = {
  skeleton: {
    graph: {
      container: {
        ...baseSkeletonStyles.graph.container,
        position: 'relative',
      },
    },
    legend: {
      display: 'flex',
      alignItems: 'center',
      gap: ({ spacing }) => spacing(2),
      height: ({ spacing }) => spacing(5),
      position: 'absolute',
      bottom: 0,
    },
  },
} satisfies Record<string, SxProps<Theme>>
